export const HEADERS = [
  'HEADER.ID',
  'HEADER.CREATED',
  'HEADER.IS-ACTIVE',
  'HEADER.UPDATED',
  'HEADER.YEAR',
  'HEADER.COMPANY-ID',
  'HEADER.QUARTER-ID',
];
